import { adviserRequest } from './api';

export const enquiryHelpOptions = [
  'Strategy and direction',
  'Growth and scaling',
  'Execution and accountability',
  'Leadership and team',
  'Something else',
] as const;
export const enquiryTimeframes = [
  'As soon as possible',
  'Within a month',
  'In the next few months',
  'Just exploring',
] as const;
export type EnquiryStatus = 'new' | 'contacted' | 'closed';
export interface ConversationRequest {
  requestId: string;
  name: string;
  email: string;
  company: string;
  website?: string;
  phone?: string;
  helpWith: string;
  message: string;
  timeframe: string;
  consent: true;
  websiteTrap?: string;
}
export interface AdviserEnquiry {
  id: string;
  practiceId: string;
  firmName: string;
  name: string;
  email: string;
  company: string;
  website: string | null;
  phone: string | null;
  helpWith: string;
  message: string;
  timeframe: string;
  status: EnquiryStatus;
  readAt: string | null;
  createdAt: string;
}
export type AdviserEnquiryNotification = Pick<
  AdviserEnquiry,
  'id' | 'practiceId' | 'firmName' | 'name' | 'company' | 'helpWith' | 'createdAt' | 'readAt'
>;
export interface AdviserLinkNotification {
  id: string;
  type: 'adviser_link_requested' | 'adviser_link_approved';
  title: string;
  message: string;
  actionUrl: string;
  createdAt: string;
  readAt: string | null;
}
const json = (method: string, body?: unknown) => ({
  method,
  ...(body !== undefined && { body: JSON.stringify(body) }),
});
export const enquiriesApi = {
  submit: (slug: string, body: ConversationRequest) =>
    adviserRequest<{ id: string; createdAt: string }>(
      `/api/public/advisers/${encodeURIComponent(slug)}/enquiries`,
      json('POST', body),
      true
    ),
  list: (practiceId: string) =>
    adviserRequest<AdviserEnquiry[]>(`/api/advisers/${encodeURIComponent(practiceId)}/enquiries`),
  update: (practiceId: string, id: string, body: { status?: EnquiryStatus; read?: true }) =>
    adviserRequest<AdviserEnquiry>(
      `/api/advisers/${encodeURIComponent(practiceId)}/enquiries/${encodeURIComponent(id)}`,
      json('PATCH', body)
    ),
  notifications: () =>
    adviserRequest<AdviserEnquiryNotification[]>('/api/adviser-enquiries/notifications'),
  markNotificationRead: (id: string) =>
    adviserRequest<{ id: string; readAt: string }>(
      `/api/adviser-enquiries/notifications/${encodeURIComponent(id)}/read`,
      json('PATCH')
    ),
  linkNotifications: () =>
    adviserRequest<AdviserLinkNotification[]>('/api/adviser-link-notifications'),
  markLinkNotificationRead: (id: string) =>
    adviserRequest<{ id: string; readAt: string }>(
      `/api/adviser-link-notifications/${encodeURIComponent(id)}/read`,
      json('PATCH')
    ),
};
export const ENQUIRIES_CHANGED_EVENT = 'stratplan:adviser-enquiries-changed';
export const NOTIFICATIONS_CHANGED_EVENT = 'stratplan:notifications-changed';
export const enquiryWorkspaceUrl = (practiceId: string, enquiryId: string) =>
  `/adviser?${new URLSearchParams({ practice: practiceId, tab: 'enquiries', enquiry: enquiryId })}`;
